// extracted by mini-css-extract-plugin
export default {"cell_wrapper":"ProjectProtocolsTableCell_cell_wrapper__xFvva"};